import Footer from "./common/footer.jsx";
import Header from "./common/header.jsx";
import styled from "styled-components";

import { useEffect, useState } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import { store } from "./store/store.js";
import { ToastContainer } from "react-toastify";
import useUserAuthActions from "./hooks/useUserStorage.jsx";

const CustomToast = styled(ToastContainer)`
  z-index: 10000;
  width: "400px";
  font-weight: 600;
  font-size: 16px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const App = () => {
  document.title = "모노티";
  const { pathname } = useLocation();
  const [isComponent, setIsComponent] = useState(true);
  const { checkAndLogin } = useUserAuthActions();
  const user = useSelector((state) => state?.user?.data[0]);

  useEffect(() => {
    if (!window.Kakao || !window.Kakao.isInitialized()) {
      // Kakao.init("b9886faecde9faa67a51166600a9d107"); // 개발 환경에 맞는 API 키 사용
      Kakao.init("4970bf08e349ccf4b295296035944317"); // 운영 환경에 맞는 API 키 사용
    }

    if (!user) {
      checkAndLogin();
    }
  }, [user, checkAndLogin]);

  function ScrollToTop() {
    useEffect(() => {
      window.scrollTo(0, 0);
      changeBodyClassName();
      const pathNames = ["self-service", "stamp", "share-report", "coupon", "menu"];
      setIsComponent(!pathNames.some((com) => pathname.includes(com)));
    }, [pathname]);

    return null;
  }

  return (
    <Provider store={store}>
      <CustomToast
        position="top-center"
        theme="light"
        pauseOnHover
        hideProgressBar={true}
        autoClose={1000}
        closeButton={false}
        limit={1}
      />
      <ScrollToTop />
      {isComponent && <Header type="main" />}
      <Outlet />
      {isComponent && <Footer />}
    </Provider>
  );
};

export default App;
